import dayjs from 'dayjs';

export const CHANGELOG_GROUPS = [
  { value: 'all', label: 'All' },
  { value: 'steps', label: 'Steps' },
  { value: 'general', label: 'General' },
  { value: 'cycle', label: 'Cycle' },
  { value: 'detection', label: 'Detection' },
  { value: 'advanced', label: 'Advanced' },
];

// `kind` comes from the backend field registry (Organization/task_changelog.py)
export const formatChangeValue = (change, value) => {
  if (value === null || value === undefined || value === '') return 'Not set';
  if (Array.isArray(value)) return value.length ? value.join(', ') : 'None';
  switch (change.kind) {
    case 'bool':
      return value ? 'On' : 'Off';
    case 'seconds':
      return `${value} s`;
    case 'fraction_percent':
      return `${Math.round(Number(value) * 10000) / 100}%`;
    case 'datetime':
      return dayjs(value).format('DD MMM YYYY, HH:mm');
    case 'json':
    case 'long_text':
      return 'Updated';
    default:
      return String(value);
  }
};

export const formatDateTime = (value) =>
  value ? dayjs(value).format('DD MMM YYYY, HH:mm:ss') : 'unknown date';
